import { useAuth0 } from '@auth0/auth0-react';
import { Button, Card, Dropdown, Icons, Menu, Space } from '@pankod/refine-antd';
import applicationImage from 'assets/images/application1.svg';
import { AppInstanceDeleteModal, AppInstanceEditModal } from 'components/modal';
import { useUserData } from 'hooks';
import { useState } from 'react';
import useAppInstanceStore from 'store/useAppInstanceStore';

type AppInstanceSelectCardProps = {
  id: string;
  name: string;
};

export const ModifiedAppInstanceSelectCard: React.FC<AppInstanceSelectCardProps> = ({
  id,
  name,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { loginWithRedirect } = useAuth0();
  const { user } = useUserData();
  const { appInstances, currentAppInstance, setCurrentAppInstance } = useAppInstanceStore();

  const isCurrentAppInstance = currentAppInstance ? currentAppInstance.id === id : false;

  const handleSelect = () => {
    if (!user) return;

    const selectedAppInstance = appInstances.find((app) => app.id === id);
    if (selectedAppInstance) {
      window.localStorage.clear();
      loginWithRedirect({ orgId: user.organization.id, platformId: id });
      setCurrentAppInstance(selectedAppInstance);
    }
  };

  const moreMenu = () => (
    <Menu mode="vertical" onClick={({ domEvent }) => domEvent.stopPropagation()}>
      <Menu.Item key="edit" onClick={() => setIsEditModalOpen(true)}>
        <Space style={{ marginRight: '0.5rem' }}>
          <Icons.EditOutlined />
        </Space>
        <Space>Edit</Space>
      </Menu.Item>
      {!isCurrentAppInstance && (
        <Menu.Item key="delete" onClick={() => setIsDeleteModalOpen(true)}>
          <Space style={{ marginRight: '0.5rem' }}>
            <Icons.DeleteOutlined style={{ color: '#f44336' }} />
          </Space>
          <Space style={{ color: '#f44336' }}>Delete</Space>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <AppInstanceEditModal
        appId={id}
        isModalOpen={isEditModalOpen}
        closeModal={() => setIsEditModalOpen(false)}
      />
      <AppInstanceDeleteModal
        appId={id}
        isModalOpen={isDeleteModalOpen}
        closeModal={() => setIsDeleteModalOpen(false)}
      />

      <Card style={{ width: '250px', display: 'none' }}>
        <div style={{ width: '100%', marginBottom: '1.5rem' }}>
          <span>
            <img
              src={applicationImage}
              alt="Avatar"
              style={{
                width: '16px',
                display: 'inline-block',
                marginRight: '0.5rem',
                marginBottom: '3px',
              }}
            />
          </span>
          <Space style={{ fontSize: '1rem', fontWeight: 700 }}>{name}</Space>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Button style={{ width: '80%', borderRadius: '3px' }} onClick={handleSelect}>
            Select
          </Button>
          <Dropdown overlay={moreMenu()} trigger={['click']}>
            <Icons.MoreOutlined onClick={(e) => e.stopPropagation()} style={{ fontSize: 24 }} />
          </Dropdown>
        </div>
      </Card>
      <div
        style={{
          border: '1px solid #D9D9D9',
          padding: '10px 18px',
          borderRadius: 42,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
        }}
      >
        <Space style={{ fontSize: '14px', fontWeight: 400, color: '#000000D9' }}>{name}</Space>
        <Dropdown overlay={moreMenu()} trigger={['click']}>
          <Icons.MoreOutlined onClick={(e) => e.stopPropagation()} style={{ fontSize: 18 }} />
        </Dropdown>
      </div>
    </>
  );
};
